<style>
.xo-logo{
  width: 28px;
  height: 28px;
  margin: 5px 10px;
}

.demo-upload-list {
  display: inline-block;
  width: 100%;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>

<template>
  <div>
    <div class="xo-top-block">
      <img src="../../assets/images/ai_icon.png" class="xo-logo"/>
    </div>
    <div class="xo-left-block">
      <leftComponent @on-load-resource="handleLoadResource"/>
    </div>
    <div class="xo-bottom-block"  v-show="isBeginSearch">
      <bottomComponent ref="bottomComponentRef"/>
    </div>
    <div class="xo-right-block"  v-show="isBeginSearch">
      <rightComponent ref="rightComponentRef"/>
    </div>
  </div>
</template>

<script>
import leftComponent from './demandComponents/Left.vue'
import bottomComponent from './demandComponents/Bottom.vue'
import rightComponent from './demandComponents/Right.vue'

export default {
  components: {
    leftComponent, bottomComponent, rightComponent
  },
  data () {
    return {
      isBeginSearch: false
    }
  },
  methods: {
    handleLoadResource (selectImg) {
      this.isBeginSearch = true
      this.$refs.bottomComponentRef.initPageData(selectImg)
      this.$refs.rightComponentRef.initPageData(selectImg)
    }
  }
}
</script>
